import { INTERNATIONAL_CUSTOMS_WEIGHT_UNITS } from "@redotech/redo-model/inventory/international-customs-upload";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const isoCountryCode = z
  .string()
  .regex(/^[A-Z]{2}$/, "Must be an ISO 3166-1 alpha-2 country code");

export const updateReturnNetworkProductVariant = unaryRpc({
  name: "updateReturnNetworkProductVariant" as const,
  input: z.object({
    productId: z.string(),
    upc: z.string().max(255).nullable().optional(),
    sku: z.string().max(255).nullable().optional(),
    weight: z
      .object({
        value: z.number().positive().max(99_999_999.99),
        unit: z.enum(INTERNATIONAL_CUSTOMS_WEIGHT_UNITS),
      })
      .nullable()
      .optional(),
    price: z.number().nonnegative().nullable().optional(),
    currency: z.string().length(3).nullable().optional(),
    originCountry: isoCountryCode.nullable().optional(),
    hsCode: z.string().max(50).nullable().optional(),
    manufacturerId: z.string().nullable().optional(),
  }),
  output: z.object({ ok: z.literal(true) }),
});
